/**
 * Constante de los estados de la Republica mexicana
 */
export const MEX_STATES: { id: string, value: string, name: string, inegiId?: number, abrev?: string[] }[] = [
  { id: '1', inegiId: 1, value: 'AS', name: 'Aguascalientes', abrev: ['AGU', 'Ags', 'AS'] },
  { id: '2', inegiId: 2, value: 'BC', name: 'Baja California', abrev: ['BCN', 'BC', 'BC'] },
  { id: '3', inegiId: 3, value: 'BS', name: 'Baja California Sur', abrev: ['BCS', 'BCS', 'BS'] },
  { id: '4', inegiId: 4, value: 'CC', name: 'Campeche', abrev: ['CAM', 'Camp', 'CC'] },
  { id: '5', inegiId: 5, value: 'CL', name: 'Coahuila', abrev: ['COA', 'Coah', 'CL'] },
  { id: '6', inegiId: 6, value: 'CM', name: 'Colima', abrev: ['COL', 'Col', 'CM'] },
  { id: '7', inegiId: 7, value: 'CS', name: 'Chiapas', abrev: ['CHP', 'Chis', 'CS'] },
  { id: '8', inegiId: 8, value: 'CH', name: 'Chihuahua', abrev: ['CHH', 'Chih', 'CH'] },
  { id: '9', inegiId: 9, value: 'DF', name: 'Ciudad de México', abrev: ['CMXC', 'CDMX', 'DF', 'CX', 'CDMX'] },
  { id: '10', inegiId: 10, value: 'DG', name: 'Durango', abrev: ['DUR', 'Dgo', 'DG'] },
  { id: '11', inegiId: 11, value: 'MC', name: 'Estado de México', abrev: ['MEX', 'EM', 'MC', 'Gto'] },
  { id: '12', inegiId: 12, value: 'GT', name: 'Guanajuato', abrev: ['GUA', 'Gro', 'GT'] },
  { id: '13', inegiId: 13, value: 'GR', name: 'Guerrero', abrev: ['GRO', 'Hgo', 'GR'] },
  { id: '14', inegiId: 14, value: 'HG', name: 'Hidalgo', abrev: ['HID', 'Jal', 'HG'] },
  { id: '15', inegiId: 15, value: 'JC', name: 'Jalisco', abrev: ['JAL', 'Mex', 'JC'] },
  { id: '16', inegiId: 16, value: 'MN', name: 'Michoacán', abrev: ['MIC', 'Mich', 'MN'] },
  { id: '17', inegiId: 17, value: 'MS', name: 'Morelos', abrev: ['MOR', 'Mor', 'MS'] },
  { id: '18', inegiId: 18, value: 'NT', name: 'Nayarit', abrev: ['NAY', 'Nay', 'NT'] },
  { id: '19', inegiId: 19, value: 'NL', name: 'Nuevo León', abrev: ['NLE', 'NL', 'NL'] },
  { id: '20', inegiId: 20, value: 'OC', name: 'Oaxaca', abrev: ['OAX', 'Oaxaca', 'OC'] },
  { id: '21', inegiId: 21, value: 'PL', name: 'Puebla', abrev: ['PUE', 'Pue', 'PL'] },
  { id: '22', inegiId: 22, value: 'QT', name: 'Querétaro', abrev: ['QUE', 'QRO', 'Qro', 'QT'] },
  { id: '23', inegiId: 23, value: 'QR', name: 'Quintana Roo', abrev: ['ROO', 'Q_Roo', 'QR'] },
  { id: '24', inegiId: 24, value: 'SP', name: 'San Luis Potosí', abrev: ['SLP', 'SLP', 'SP'] },
  { id: '25', inegiId: 25, value: 'SL', name: 'Sinaloa', abrev: ['SIN', 'Sin', 'SL'] },
  { id: '26', inegiId: 26, value: 'SR', name: 'Sonora', abrev: ['SON', 'Son', 'SR'] },
  { id: '27', inegiId: 27, value: 'TC', name: 'Tabasco', abrev: ['TAB', 'Tab', 'TC'] },
  { id: '28', inegiId: 28, value: 'TS', name: 'Tamaulipas', abrev: ['TAM', 'Tamps', 'TS'] },
  { id: '29', inegiId: 29, value: 'TL', name: 'Tlaxcala', abrev: ['TLA', 'Tlax', 'TL'] },
  { id: '30', inegiId: 30, value: 'VZ', name: 'Veracruz', abrev: ['VER', 'Ver', 'VZ'] },
  { id: '31', inegiId: 31, value: 'YN', name: 'Yucatán', abrev: ['YUC', 'Yuc', 'YN'] },
  { id: '32', inegiId: 32, value: 'ZS', name: 'Zacatecas', abrev: ['ZAC', 'Zac', 'ZS'] },
  { id: '34', inegiId: 34, value: 'NE', name: 'Nacido en el Extranjero', abrev: ['NE', 'Ne', 'NE']}
];

export const MEX_INEGI_STATES = [
  { id: '1', name: 'Aguascalientes' },
  { id: '2', name: 'Baja California' },
  { id: '3', name: 'Baja California Sur' },
  { id: '4', name: 'Campeche' },
  { id: '5', name: 'Coahuila' },
  { id: '6', name: 'Colima' },
  { id: '7', name: 'Chiapas' },
  { id: '8', name: 'Chihuahua' },
  { id: '9', name: 'Distrito Federal' },
  { id: '10', name: 'Durango' },
  { id: '11', name: 'Guanajuato' },
  { id: '12', name: 'Guerrero' },
  { id: '13', name: 'Hidalgo' },
  { id: '14', name: 'Jalisco' },
  { id: '15', name: 'México' },
  { id: '16', name: 'Michoacán' },
  { id: '17', name: 'Morelos' },
  { id: '18', name: 'Nayarit' },
  { id: '19', name: 'Nuevo León' },
  { id: '20', name: 'Oaxaca' },
  { id: '21', name: 'Puebla' },
  { id: '22', name: 'Querétaro' },
  { id: '23', name: 'Quintana Roo' },
  { id: '24', name: 'San Luis Potosí' },
  { id: '25', name: 'Sinaloa' },
  { id: '26', name: 'Sonora' },
  { id: '27', name: 'Tabasco' },
  { id: '28', name: 'Tamaulipas' },
  { id: '29', name: 'Tlaxcala' },
  { id: '30', name: 'Veracruz' },
  { id: '31', name: 'Yucatán' },
  { id: '32', name: 'Zacatecas' }
]

export const ESTADOS_MX = {
  AS: 'AGUASCALIENTES',
  BC: 'BAJA_CALIFORNIA',
  BS: 'BAJA_CALIFORNIA_SUR',
  CC: 'CAMPECHE',
  CL: 'COAHUILA',
  CM: 'COLIMA',
  CS: 'CHIAPAS',
  CH: 'CHIHUAHUA',
  DF: 'DISTRITO_FEDERAL',
  CDMX: 'DISTRITO_FEDERAL',
  DG: 'DURANGO',
  GT: 'GUANAJUATO',
  GR: 'GUERRERO',
  HG: 'HIDALGO',
  JC: 'JALISCO',
  MC: 'ESTADO_DE_MEXICO',
  NE: 'NO_ESPECIFICADO',
  MN: 'MICHOACAN',
  MS: 'MORELOS',
  NT: 'NAYARIT',
  NL: 'NUEVO_LEON',
  OC: 'OAXACA',
  PL: 'PUEBLA',
  QT: 'QUERETARO',
  QR: 'QUINTANA_ROO',
  SP: 'SAN_LUIS_POTOSI',
  SL: 'SINALOA',
  SR: 'SONORA',
  TC: 'TABASCO',
  TS: 'TAMAULIPAS',
  TL: 'TLAXCALA',
  VZ: 'VERACRUZ',
  YN: 'YUCATAN',
  ZS: 'ZACATECAS'
};